<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->

                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">

                        <!--Radio Button-->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-9 paddingleft0">
                                <input type="radio" id="fetchFromExcede" value="1" v-model="isExcede">
                                <label for="fetchFromExcede">Fetch from Excede</label>
                                <input type="radio" id="excelImport" value="2" v-model="isExcede">
                                <label for="excelImport">Excel Import</label>
                            </div>
                        </div> -->

                        <!--File-->
                        <!-- <template v-if="isExcede == 2">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">File :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input id="file" type="file" ref="file" v-on:change="onImageChange" class="form-control" :allowedExtensions="extensions">
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{fileError}}</span>
                                </div>
                            </div>
                        </template> -->

                        <!-- Customer -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Customer :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="customerId"
                                    name="customerId"
                                    id="customerId"
                                    label="text"
                                    :filterable="true"
                                    :options="customerArr"
                                    :clearable=false
                                    @input="onChnageCustomer()"
                                    placeholder="Select Customer">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{customerError}}</span>
                            </div>
                        </div>

                        <!-- Reimport All Parts -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">
                                    <label class="container" style="width 175px; padding: 0px !important;">
                                        <input type="checkbox" id="checkbox" v-model="reImportAllParts">
                                        Reimport All Parts
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="confirmationAlert()">
                        <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="confirmationAlert ()"></input>-->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                    </div>

                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import axios from 'axios'

    var moment = require('moment-timezone');

    export default {
        name: 'AddUpdateParts',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Import Parts",

                isExcede : 1,
                file : '',
                name : '',
                fileError : "",
                customerId: "",
                customerArr: [],
                customerError: "",

                buttonNames : {
                    save : 'Save',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                permissionRendered : false,
                extensions: '.doc, .docx, .xls, .xlsx',
                reImportAllParts: false,
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "listParts");
        },
        watch: {
        },
        mounted: function () {
            // EventBus.$emit('showHeader', true);
            $("#alertError").hide();
            self.getAllPermissions();
            self.removeErrorMessageOnInput();

            var path = window.location.pathname;
            var segments = path.split("/");
            self.getAllCustomer();
        },
        beforeDestroy() {
            // EventBus.$off('all-permissions');
        },
        methods: {
            onChnageCustomer:function() {
                self.customerError = "";
            },
            getAllCustomer: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/customer/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.customerArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            onImageChange(e) {
                self.fileError = "";
                self.file = self.$refs.file.files[0];
            },
            validateForm: function() {
                var error = false;
                self.customerError = '';
                self.fileError = '';

                if (self.customerId == null || !self.customerId.value) {
                    self.customerError = "The Customer field is required.";
                    error = true;
                }
                if(self.isExcede == 2) {
                    if(self.file == "") {
                        self.fileError = "Select File";
                        error = true;
                    }
                }
                return error;
            },
            confirmationAlert(flag) {
                var error = self.validateForm();
                if(!error) {
                    var checkboxVale = self.reImportAllParts ? 1 : 0;
                    if(checkboxVale) {
                        self.$swal({
                            title: "Are you sure?",
                            text: "You want to do this, this will reset the Customer's Inventory",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Yes Change it!",
                            cancelButtonText: "No, Keep it!",
                            showCloseButton: true,
                            showLoaderOnConfirm: true
                        })
                        .then(result => {
                            if (result.value) {
                                self.addUpdateParts(flag);
                            }
                        });
                    } else {
                        self.addUpdateParts(flag);
                    }
                }
            },
            addUpdateParts (flag) { 
                self.buttonNames.save = "Saving ...";
                self.disableButtons.save = true;
                self.disableButtons.cancel = true;

                let formData = new FormData();
                if(self.isExcede == 2) {
                    formData.append('file', self.file);
                }
                formData.append('customer_id', self.customerId.value);
                formData.append('reImportAllParts', self.reImportAllParts ? 1 : 0);
                if(self.isExcede == 2) {
                    var config = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization:localStorage.getItem("access_token")
                        }
                    };
                } else {
                    var config = {
                        headers: {
                            Authorization:localStorage.getItem("access_token")
                        }
                    };
                }
                HTTP.post("import-parts", formData, config)
                    .then(function(response) {
                        self.buttonNames.save = "Save";
                        self.disableButtons.save = false;
                        self.disableButtons.cancel = false;

                        if(response.status == 200){
                            self.clearDataOnSaveAndContinue();
                            self.showSAlert(response.data.message,'success',false);
                            setTimeout(function () {
                                self.buttonBack();
                            }, 3000);
                        }
                        if(response.status == 201) {
                            // self.showSAlert(response.data.content.file[0],'error',false);
                            self.showSAlert("The file must be a file of type: xls, xlsx.", 'error', false);
                            self.clearDataOnSaveAndContinue();
                        }
                        if(response.status == 202){
                            self.showSAlert(response.data.message,'error',false);
                        }
                    })
                    .catch(function(err) {
                        self.buttonNames.save = "Save";
                        self.disableButtons.save = false;
                        self.disableButtons.cancel = false;
                        self.showSAlert(err,'error',false);
                    });
                
            },
            removeErrorMessageOnInput : function () {
                /* Remove error on input */
                $("#file").keyup(function () {
                    self.fileError = "";
                });
            },
            showAlertOnSave : function (alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack : function () {
                self.$router.push('/list-parts');
            },
            clearDataOnSaveAndContinue : function () {
                if(self.isExcede == 2) {
                    const input = self.$refs.file;
                    input.type = 'text';
                    input.type = 'file';
                }
                self.customerId = "";
                self.isExcede = 1;
            },
        }
    }
</script>

<style>
  .field-icon {
    float: right;
    margin-right: 8px;
    margin-top: -23px;
    position: relative;
    z-index: 2;
    cursor:pointer;
  }

  .container{
    padding-top:50px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/ImportParts.vue